import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import {
  faTwitter,
  faFacebook,
  faLinkedin,
  faYoutube,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../environments/environment";
import { DynamicComponent, Regions } from "../models/region-component.type";
import { Router } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import {
  socialMediaIconsMX,
  contactIconsMX,
  solutionsLinksMX,
  socialMediaIconsBR,
  contactIconsBR,
  solutionsLinksBR,
  insightsLink,
  solutionsLinksLatam,
  contactIconsLatam,
  socialMediaIconsLatam,
  contactIconsCO,
  socialMediaIconsCO
} from "./footer-links";
import {
  ProductCatalogService,
  ProductNavLink
} from "../services/product-catalog.service";
import { ProductService } from "../services/products.service";
import { SolutionMenuItem } from "../models/products.model";
import { SiilaTranslationService } from "../services/siila-translation.service";
import { StaticImagesSEOService } from "../services/static-images.service";
import { ImageSEO } from "../models/image-seo.model";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit, DynamicComponent {
  ALLOWS_REGIONS: Regions[] = [Regions.BR, Regions.MX];

  currentYear: number = new Date().getFullYear();
  fitWithFeatureBanner: boolean = false;
  handsetMode: boolean = false;
  appLink = environment.serverURL;
  solutions: SolutionMenuItem[];
  browserLang: string = "en";

  socialMediaIconsBR: Link[] = socialMediaIconsBR;
  contactIconsBR: Link[] = contactIconsBR;
  solutionsLinksBR: Link[] = solutionsLinksBR;
  insightsLink: Link[] = insightsLink;

  //MX Links
  socialMediaIconsMX: Link[] = socialMediaIconsMX;
  contactIconsMX: Link[] = contactIconsMX;
  solutionsLinksMX: Link[] = solutionsLinksMX;
  //MX LInks end

  contactIconsCO: Link[] = contactIconsCO;
  socialMediaIconsCO: Link[] = socialMediaIconsCO;

  //Latam Links
  socialMediaIconsLatam: Link[] = socialMediaIconsLatam;
  contactIconsLatam: Link[] = contactIconsLatam;
  solutionsLinksLatam: Link[] = solutionsLinksLatam;
  //Latam LInks end

  termsOfUseUrl: string;
  privacyUrl: string;

  currentEnv: string;
  currentSocial: Link[] = [];
  currentContact: Link[] = [];
  /**
   * Products column. Built from `ProductCatalogService` — the same source the
   * header dropdown reads — so the footer can no longer advertise a URL the menu
   * does not, which is what let non-canonical product URLs into the sitemaps.
   */
  currentProduct: ProductNavLink[] = [];
  currentSolution: Link[] = [];
  linkedingSEO: ImageSEO;
  youtubeSEO: ImageSEO;
  tiktokSEO: ImageSEO;
  facebookSEO: ImageSEO;
  instagramSEO: ImageSEO;
  twitterSEO: ImageSEO;
  spotifySEO: ImageSEO;
  footerLogoTitle: string;
  constructor(
    private breakpointObserver: BreakpointObserver,
    private staticImgSrv: StaticImagesSEOService,
    private productService: ProductService,
    private productCatalog: ProductCatalogService,
    private siilaTranslationService: SiilaTranslationService
  ) {
    this.currentEnv = environment.platformId;
    this.browserLang = this.siilaTranslationService.getCurrentLanguage();
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.handsetMode = result.matches;
      });
  }

  ngOnInit(): void {
    this.linkedingSEO = this.staticImgSrv.getLinkedinSEO();
    this.youtubeSEO = this.staticImgSrv.getYoutubeSEO();
    this.facebookSEO = this.staticImgSrv.getFacebookSEO();
    this.instagramSEO = this.staticImgSrv.getInstagramSEO();
    this.twitterSEO = this.staticImgSrv.getTwitterSEO();
    this.tiktokSEO = this.staticImgSrv.getTikTokSEO();
    this.spotifySEO = this.staticImgSrv.getSpotifySEO();
    this.footerLogoTitle = this.siilaTranslationService.getTranslationFromJSONFiles(
      "imgSEO.footerTitle"
    );

    this.currentProduct = this.productCatalog.getNavLinks();

    if (this.currentEnv.includes("mx")) {
      this.currentSocial = this.socialMediaIconsMX;
      this.currentContact = this.contactIconsMX;
      this.currentSolution = this.solutionsLinksMX;
    } else if (this.currentEnv.includes("br")) {
      this.currentSocial = this.socialMediaIconsBR;
      this.currentContact = this.contactIconsBR;
      this.currentSolution = this.socialMediaIconsBR;
    } else if (this.currentEnv.includes("latam")) {
      this.currentSocial = this.socialMediaIconsLatam;
      this.currentContact = this.contactIconsLatam;
      this.currentSolution = this.solutionsLinksLatam;
    } else {
      this.currentSocial = this.socialMediaIconsCO;
      this.currentContact = this.contactIconsCO;
      this.currentSolution = this.solutionsLinksMX;
    }

    if (this.currentSocial) {
      for (let i = 0; i < this.currentSocial.length; i++) {
        let socialMediaLink: Link = this.currentSocial[i];
        let seo: ImageSEO = null;
        switch (i) {
          case 0:
            seo = this.linkedingSEO;
            break;
          case 1:
            seo = this.youtubeSEO;
            break;
          case 2:
            seo = this.facebookSEO;
            break;
          case 3:
            seo = this.instagramSEO;
            break;
          case 4:
            seo = this.twitterSEO;
            break;
          case 5:
            seo = this.tiktokSEO;
            break;
          case 6:
            seo = this.spotifySEO;
        }
        socialMediaLink.alt = seo.alt;
        socialMediaLink.title = seo.title;
      }
    }

    this.termsOfUseUrl = this.siilaTranslationService.buildLocalizedPath(
      "/terms-of-use"
    );
    this.privacyUrl = this.siilaTranslationService.buildLocalizedPath(
      "/privacy-policy"
    );

    // Localize the About contact link so English users keep the `/lang/en`
    // suffix instead of falling back to the deployment's default-language page.
    // `buildLocalizedPath` strips any pre-existing `/lang/` segment first, so
    // this stays idempotent. External contact links (tel:/mailto:/https:) are
    // left untouched. Product links arrive from the catalog already localized.
    this.currentContact.forEach(contact => {
      if (contact.link && contact.link.startsWith("/")) {
        contact.link = this.siilaTranslationService.buildLocalizedPath(
          contact.link
        );
      }
    });

    // The "website" contact link (globe icon) is this deployment's own absolute
    // homepage. Point it at the canonical non-www base URL from environment.* to
    // avoid the www -> non-www 301, and append /lang/en for English users
    // (LATAM's default is already `en`, so it stays a clean URL). Applies to
    // every platform (BR, MX, CO, LATAM).
    const websiteLink = this.currentContact.find(
      contact => contact.matIcon === "public"
    );
    if (websiteLink) {
      websiteLink.link = this.siilaTranslationService.buildCrossCountryUrl(
        this.currentEnv,
        "",
        this.siilaTranslationService.getCurrentLanguage()
      );
    }

    this.productService.getSolutionList().subscribe(solutions => {
      this.solutions = solutions;
    });
  }

  /**
   * Build the real, language-correct href for a footer Solutions link — the
   * anchors previously had no href at all (dead links). Delegates to the single
   * source of truth `buildSolutionDetailUrl` (slug re-derived to the active
   * language + platform `/lang/<code>` suffix), so English users keep the
   * `/lang/en` suffix instead of landing on the deployment's default-language
   * page. Same builder the detail page uses to normalize its own URL.
   */
  getSolutionUrl(link: SolutionMenuItem): string {
    return this.siilaTranslationService.buildSolutionDetailUrl(
      link.solutionName,
      link.id
    );
  }
}

export interface Link {
  ref?: string;
  link: string;
  text?: string;
  textEs?: string;
  matIcon?: string;
  target?: string;
  class?: string;
  title?: string;
  alt?: string;
}
